export const getMapOrderStats = (orders = []) => orders.reduce(
  (stats, order) => {
    if (order?.type === 'return') {
      return stats;
    }

    stats.orderCount += 1;
    stats.volumeM3 += Number(order?.packagesVolumeM3) || 0;

    return stats;
  },
  { orderCount: 0, volumeM3: 0 }
);
